import React from 'react';
import {Link} from 'react-router-dom';
import {Popup} from 'semantic-ui-react';

const userTdeView = (campaingNo) => ({
  'path': `/editar-campana/${campaingNo}`,
  'icon': 'edit',
  'contentText': 'Editar Campaña',
});

const nonUserTdeView = (campaingNo) => ({
  'path': `/ver-campana/${campaingNo}`,
  'icon': 'visibility',
  'contentText': 'Ver Campaña',
});

const CampaignViewIcon = ({campaingNo, isUserTde}) => {
  const view = isUserTde ? userTdeView(campaingNo) : nonUserTdeView(campaingNo);

  return (
    <Popup
      trigger={
        <Link
          to={view.path}
          target='_blank'
          className='edit-campaign-link'
        >
          <span className='link'>
            <i className='material-icons'>
              {view.icon}
            </i>
          </span>
        </Link>
      }
      content={view.contentText}
      position='top center'
      inverted
    />
  );
};

export default CampaignViewIcon;
